export default __webpack_public_path__ + "static/media/Skolar.c9e9f018.jpg";